<template>
  <div class="estimate-detail">
    <LableContent label="概算明细" hasCollapse showFullScreen height="450px">
      <TabBtn
        ref="tabBtnRef"
        :tabs="tabs"
        :active-tab="tabActive"
        @tab-click="initData"
        height="100%"
      >
        <template slot="btn">
          <el-button type="primary" size="mini" @click="handleGlobalEstimate">
            全局概算
          </el-button>
          <!-- <el-button type="primary" size="mini" @click="handleEstimateAdjustment">
          估算调价
        </el-button> -->
        </template>
        <template>
          <SimpleTable
            ref="topTable"
            :menus="menus"
            height="50%"
            :columns="columns.top"
            :data="tableData.top"
            table-code="EstimateDetailTop"
            :loading="loading.top"
            @row-select="onRowSelectTop"
            @modify-data-change="onModifyDataChangeTop"
          />
        </template>
      </TabBtn>
    </LableContent>

    <LableContent
      label="历史数据"
      hasCollapse
      showFullScreen
      v-if="currentTab.value === 'dbe-project-unit-cost'"
      style="width: 100%"
      height="350px"
    >
      <TabBtn
        ref="tabBtnRefHistory"
        :tabs="tabsHistory"
        :active-tab="tabHistoryActive"
        height="100%"
        @tab-click="initDataHistory"
      >
        <SimpleTable
          v-if="currentTabHistory.value === 'pofeHistoryProject'"
          ref="bottomTable"
          height="50%"
          :menus="['查询', '插入', '批量删除', '批量修改']"
          :menusMergeAfter="menusMergeAfterBottom"
          :columns="columns.bottom"
          :data="tableData.bottom"
          table-code="EstimateDetailBottom"
          :loading="loading.bottom"
          :bottomFrozenRowCount="1"
          @row-select="onRowSelectBottom"
          @modify-data-change="onModifyDataChangeBottom"
        />

        <div
          class="project-overview-box"
          v-if="currentTabHistory.value === 'projectOverview'"
        >
          <SimpleTable
            :allowMultiSelect="false"
            ref="tableLeft"
            :loading="loadingLeft"
            :columns="columnsLeft"
            :data="tableDataLeft"
            @row-select="handleRowSelectLeft"
          />
          <SimpleTable
            :allowMultiSelect="false"
            :show-index="false"
            ref="tableCenter"
            :loading="loadingCenter"
            :columns="columnsCenter"
            :data="tableDataCenter"
            @modify-data-change="handleModifyDataChangeCenter"
          />
          <SimpleTable
            :show-index="false"
            ref="tableRight"
            :loading="loadingRight"
            :columns="columnsRight"
            :data="tableDataRight"
            @modify-data-change="handleModifyDataChangeRight"
          />
        </div>
      </TabBtn>
    </LableContent>

    <LableContent
      label="概算指标"
      hasCollapse
      showFullScreen
      v-if="
        currentTab.value === 'dbe-project-unit-cost' &&
        currentTabHistory.value === 'pofeHistoryProject'
      "
      style="width: 100%"
      height="350px"
      bottomPadding="10px"
    >
      <SimpleTable
        ref="bottomZb"
        style="height: 100%"
        height="50%"
        :menus="['查询', '批量删除', '批量修改']"
        :columns="columns.bottomZb"
        :data="tableData.bottomZb"
        table-code="EstimateDetailBottomZb"
        :loading="loading.bottomZb"
        :bottomFrozenRowCount="1"
        @modify-data-change="onModifyDataChangeBottomZb"
      />
    </LableContent>

    <LableContent
      label="动态概算"
      hasCollapse
      showFullScreen
      height="450px"
      topPadding="0px"
      bottomPadding="10px"
    >
      <div class="left-right-box1" style="height: 100%">
        <SimpleTable
          width="70%"
          ref="leftTable"
          :columns="columns.left"
          :data="tableData.left"
          table-code="EstimateDetailLeft"
          :loading="loading.left"
        />
        <SimpleTable
          width="calc(30% - 11px)"
          ref="rightTable"
          :menus="['查询', '上传', '批量删除']"
          :columns="columns.right"
          :data="tableData.right"
          table-code="EstimateDetailRight"
          :loading="loading.right"
          :uploadParams="uploadParams"
          @cell-dblclick="handleCellDblclickRight"
        />
      </div>
    </LableContent>

    <SelectBaseAmountDialog
      ref="SelectBaseAmountDialog"
      @confirm="handleSelectBaseAmountDialogConfirm"
    />
    <HistoryProjectDialog
      ref="HistoryProjectDialog"
      @confirm="handleInsertHistoryConfirm"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import SelectBaseAmountDialog from './SelectBaseAmountDialog.vue'
import HistoryProjectDialog from './HistoryProjectDialog.vue'
import { tabs, tabsHistory } from './config'
import { sortRecords, addCbFn, preViewFile } from '@/utils/index'
import LableContent from '@/components/LableContent/index.vue'

export default {
  name: 'EstimateDetail',
  components: {
    SimpleTable,
    TabBtn,
    SelectBaseAmountDialog,
    HistoryProjectDialog,
    LableContent
  },
  inject: ['detailsVm'],
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tabs,
      tabActive: tabs[0].value,
      currentTab: null,

      columns: {
        top: [],
        bottom: [],
        bottomZb: [],
        left: [],
        right: []
      },
      tableData: {
        top: [],
        bottom: [],
        bottomZb: [],
        left: [],
        right: []
      },
      tabsHistory,
      tabHistoryActive: tabsHistory[0].value,
      currentTabHistory: tabsHistory[0],

      loading: {
        top: false,
        bottom: false,
        bottomZb: false,
        left: false,
        right: false
      },
      currentSelect: {
        top: null,
        bottom: null,
        bottomZb: null,
        left: null,
        right: null
      },
      uploadParams: {
        id: '',
        accept: '',
        uploadAfter: () => this.uploadAfter()
      },

      columnsLeft: [{ field: 'name', title: '工程分类', widht: 100 }],
      columnsCenter: [
        { field: 'name', title: '工程特征', widht: 100 },
        {
          field: 'featureValue',
          title: '特征值',
          width: 200,
          canModify: true,
          editModal: {
            columns: [{ field: 'name', title: '工程特征', tree: true }],
            allowMultiSelect: true,
            options: () => this.getEngineeringFeatureOptions(),
            confirm: (selectedCellInfos, res) => {
              const arr = res.map(e => e[0].originData.name)
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'featureValue', arr.join(' '))
              })
            }
          }
        }
      ],
      columnsRight: [
        { field: 'name', title: '工程参数', widht: 100 },
        {
          field: 'paramValue',
          title: '参数值',
          width: 200,
          fieldType: 'number',
          canEdit: true,
          canModify: true
        }
      ],

      tableDataLeft: [],
      tableDataCenter: [],
      tableDataRight: [],
      loadingLeft: false,
      loadingCenter: false,
      loadingRight: false
    }
  },
  computed: {
    menus() {
      if (
        ['common-cash-flow', 'common-investment-estimate'].includes(
          this.currentTab.value
        )
      ) {
        return ['查询']
      } else if (this.currentTab.value === 'dbe-project-unit-cost') {
        return ['查询', '插入', '批量修改', '批量删除']
      }
      return ['查询', '插入', '批量修改', '批量删除', '选中模板', '保存模板']
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      if (this.$refs.tabBtnRef) this.$refs.tabBtnRef.active = tabs[0].value
      for (const element of tabs) {
        const arr = [
          'common-land-cost',
          'common-charging-items',
          'common-sale-cost',
          'common-finance-cost',
          'common-ops-cost',
          'common-ops-income',
          'common-sale-income'
        ]
        if (arr.includes(element.value)) {
          const obj = element.columns.top.find(e => e.field === 'baseAmount')
          obj.handleEdit = this.handleEditBillBaseAmount
        }
      }

      this.initData(this.tabs.find(item => item.value === this.tabActive))
    },

    initData(currentTab) {
      this.currentTab = currentTab

      this.columns.top = currentTab.columns.top
      this.columns.bottom = currentTab.columns.bottom
      this.columns.bottomZb = currentTab.columns.bottomZb || []
      this.columns.left = currentTab.columns.left
      this.columns.right = currentTab.columns.right

      this.getTable({ type: 'top', code: currentTab.value })
    },
    async getTable({ type, code, isLocal = true }) {
      this.tableData[type] = []
      this.tableData.bottom = []
      this.tableData.bottomZb = []
      this.tableData.left = []
      this.tableData.right = []
      this.loading[type] = true
      const res = await this.$service.get(`/${code}/list`, {
        mainId: this.basicInfo.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs[type + 'Table'].initialized()
    },

    async getBottomTable({ type = 'bottom', isLocal = true }) {
      if (
        this.currentTabHistory.value !== 'pofeHistoryProject' ||
        this.currentTab.value !== 'dbe-project-unit-cost'
      ) {
        return
      }
      this.tableData[type] = []
      this.tableData.bottom = []
      this.tableData.bottomZb = []
      this.loading[type] = true
      const res = await this.$service.get(`/dbe-budget-history-data/list`, {
        itemId: this.currentSelect.top?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
      if (res?.data.length && isLocal) this.$refs[type + 'Table'].initialized()
    },

    // 查时间分布
    async getLeftTable(type = 'left') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const res = await this.$service.get(`/common-time-distribution/list`, {
        itemId: this.currentSelect.top?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },
    async getRightTable(type = 'right') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const res = await this.$service.get(
        `/business-file/list/${this.currentSelect.top?.id}`
      )
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    async getbottomZbTable(type = 'bottomZb') {
      this.tableData[type] = []
      this.loading[type] = true
      const res = await this.$service.get(`/dbe-cost-indicator/list`, {
        itemId: this.currentSelect.bottom?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    onRowSelectTop(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      if (this.currentSelect.top?.id === obj?.id) return
      this.currentSelect.top = obj
      this.uploadParams.id = obj?.id

      this.getBottomTable({})
      this.getLeftTable()
      this.getRightTable()
      this.getTableLeft({})
    },

    onRowSelectBottom(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      if (this.currentSelect.bottom?.id === obj?.id) return
      this.currentSelect.bottom = obj

      this.getbottomZbTable()
    },

    async onModifyDataChangeTop(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        `/${this.currentTab.value}/batch`,
        getModifyData,
        cleanModifyData,
        arr => arr.map(e => ({ ...e, mainId: this.basicInfo.id }))
      )
      this.getTableLeft({})
    },

    async onModifyDataChangeBottom(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        `/dbe-budget-history-data/batch`,
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            mainId: this.basicInfo.id,
            itemId: this.currentSelect.top?.id,
            budgetHistoryDataId: e.id
          }))
      )
      await this.getTable({
        type: 'top',
        code: this.currentTab.value,
        isLocal: false
      })
      await this.getBottomTable({})
    },

    async onModifyDataChangeBottomZb(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        `/dbe-cost-indicator/batch`,
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            mainId: this.basicInfo.id
          }))
      )
      await this.getTable({
        type: 'top',
        code: this.currentTab.value,
        isLocal: false
      })
      await this.getBottomTable({ isLocal: false })
      await this.getbottomZbTable()
    },

    async uploadAfter() {
      this.getRightTable()
    },

    menusMergeAfterBottom(contextMenuMap) {
      contextMenuMap['插入'] = () => this.handleInsertHistory()
    },

    handleInsertHistory() {
      if (!this.currentSelect.top?.id) {
        return this.$message.warning('请选择一个单项工程')
      }
      this.$refs.HistoryProjectDialog.show({
        mainId: this.basicInfo.id
      })
    },

    handleInsertHistoryConfirm(records) {
      records.forEach(row => {
        row.bhdId = row.id
        row.id = undefined
        row.adjustPriceCoefficient = 1
        // row.costBudget = totalCost
        // row.costBudgetIndicator = constructionScale
        // if (!row.costBudget || !row.constructionScale) {
        //   row.costBudgetIndicator = 0
        // } else {
        //   row.costBudgetIndicator = (
        //     row.costBudget / row.constructionScale
        //   ).toFixed(2)
        // }
      })
      const arr = records.map(row => {
        return {
          ...row,
          costBudget: row.totalCost,
          costBudgetIndicator: row.totalCostIndicator
        }
      })
      const index = this.$refs.bottomTable.handleInsert(arr)
    },

    // 全局估算
    async handleGlobalEstimate() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        `/design-budget-estimate/global-estimate/${this.basicInfo.id}`
      )
      this.detailsVm.loadingContainer = false
      if (res?.code === 200) {
        this.$message.success('操作成功')
        this.init()
        this.detailsVm.getBaseInfo(this.basicInfo.id)
      }
    },

    // 估算调价
    handleEstimateAdjustment() {},

    // 取费基数编辑
    handleEditBillBaseAmount(selectedCellInfos) {
      if (selectedCellInfos.length !== 1)
        return this.$message.warning('只能修改一条数据！')
      this.$refs.SelectBaseAmountDialog.show({
        id: this.basicInfo.id,
        selectedCellInfos: selectedCellInfos
      })
    },

    // 取费基数编辑确认
    handleSelectBaseAmountDialogConfirm(selectedCellInfos, str) {
      selectedCellInfos.forEach(cells => {
        const obj = cells[0].originData
        this.$set(obj, 'baseAmount', str)
        this.$refs.topTable.modifyData.set(obj, obj)
      })
    },

    handleCellDblclickRight(args) {
      preViewFile(args.originData?.path)
    },

    initDataHistory(currentTab) {
      this.currentTabHistory = currentTab
      this.getTableLeft({})
    },

    async getTableLeft({ isLocal = true }) {
      this.tableDataLeft = []
      this.tableDataCenter = []
      this.tableDataRight = []
      if (
        this.currentTabHistory.value === 'projectOverview' &&
        this.currentTab.value === 'dbe-project-unit-cost'
      ) {
        const res = await this.$service.get(
          '/business-engineering-classify/list',
          {
            businessId: this.currentSelect.top?.id
          }
        )
        this.tableDataLeft = sortRecords(res?.data || [])
        if (res?.data.length && isLocal) this.$refs.tableLeft.initialized()
      }
    },

    async getTableDataCenter(obj) {
      const res = await this.$service.get(
        '/business-engineering-classify/features',
        {
          classifyId: obj.id
        }
      )
      this.tableDataCenter = sortRecords(res?.data || [])
    },

    async getTableDataRight(obj) {
      const res = await this.$service.get(
        '/business-engineering-classify/params',
        {
          classifyId: obj.id
        }
      )
      this.tableDataRight = sortRecords(res?.data || [])
    },

    handleRowSelectLeft() {
      const rows = this.$refs.tableLeft.getSelectData()
      const obj = rows[0]?.[0]?.originData
      this.getTableDataCenter(obj)
      this.getTableDataRight(obj)
    },

    async handleModifyDataChangeCenter(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post(
        '/business-engineering-classify/features/batch',
        arr
      )
      if (res?.code === 200) {
        this.$message.success('保存成功')
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        cleanModifyData()
      }
    },

    async handleModifyDataChangeRight(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post(
        '/business-engineering-classify/params/batch',
        arr
      )
      if (res?.code === 200) {
        this.$message.success('保存成功')
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        cleanModifyData()
      }
    },

    async getEngineeringFeatureOptions() {
      const rows = this.$refs.tableCenter.getSelectData()
      const obj = rows[0]?.[0]?.originData
      const res = await this.$service.get(
        '/engineering-classify/feature-values',
        {
          featureId: obj.sourceId
        }
      )
      return sortRecords(res?.data || [])
    }
  }
}
</script>

<style scoped lang="less">
.estimate-detail {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;

  ::v-deep .tab-btn .table {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    > div {
      flex: 1;
      height: 33% !important;
    }
  }

  .top-table {
    height: 300px;
  }

  .bottom-table {
    height: 300px;
  }

  .left-right-box1 {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
  }

  .project-overview-box {
    height: 100% !important;
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    > div {
      flex: 1;
    }
  }
}
.history-data {
  ::v-deep .content {
    height: 100% !important;
  }
}
</style>
